module.exports = __webpack_public_path__ + "img/star.4afa2ab1.svg";